import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { beginTwitchConnect } from '../auth/beginTwitchConnect';
import { useStudioAuth } from '../hooks/useStudioAuth';
import { useStudioDocumentTitle } from '../hooks/useStudioDocumentTitle';
import { STUDIO_COPY, STUDIO_DOCUMENT_TITLES } from '../config';
import ReconnectTwitchCard from '../components/ReconnectTwitchCard';

/**
 * Connect Twitch — sign-in entry + reconnect-Twitch state.
 */
const StudioConnectPage: React.FC = () => {
  useStudioDocumentTitle(STUDIO_DOCUMENT_TITLES.connect);
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { status, applyQueryMock, needsTwitchReconnect } = useStudioAuth();
  const reconnectMode =
    needsTwitchReconnect || params.get('state') === 'reconnect';

  useEffect(() => {
    applyQueryMock(window.location.search);
  }, [applyQueryMock]);

  useEffect(() => {
    if (status === 'linked') {
      navigate('/studio/vods', { replace: true });
    }
  }, [status, navigate]);

  const handleConnect = () => {
    const shouldNavigate = beginTwitchConnect({ returnTo: '/studio/vods' });
    if (shouldNavigate) {
      navigate('/studio/vods');
    }
  };

  if (reconnectMode && status !== 'linked') {
    return (
      <div data-testid="studio-connect-reconnect">
        <ReconnectTwitchCard onReconnect={handleConnect} />
      </div>
    );
  }

  return (
    <div className="studio-page" data-testid="studio-connect">
      <header className="studio-section">
        <h1 className="studio-display text-3xl">{STUDIO_COPY.connectHeadline}</h1>
        <p className="studio-page-kicker">{STUDIO_COPY.connectBody}</p>
      </header>
      <button
        type="button"
        className="studio-btn-primary"
        onClick={handleConnect}
        data-testid="studio-connect-cta"
      >
        {STUDIO_COPY.connectCta}
      </button>
    </div>
  );
};

export default StudioConnectPage;
